'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.appconfgroups.show', [])
  .controller('AppConfGroupsShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/show/index.js